import IconCursorGrab from '@/assets/cursors_static/cursor_grab.svg';
import IconCursorGrabbing from '@/assets/cursors_static/cursor_grabbing.svg';
import { use_effect } from '@/hooks/_base/use_effect';
import { FunctionComponent, SVGProps } from 'react';

export function HOOK_REACT_FLOW__custom_cursors() {
  /*
   * EFFECTS
   */

  use_effect(() => {
    let style_tag = create_style_tag_custom_cursors();

    return () => void document.head.removeChild(style_tag);
  }, []);

  /*
   * METHODS
   */

  function create_style_tag_custom_cursors() {
    const out = document.createElement('style');
    out.textContent = `
        .react-flow__pane.draggable ${get_cursor(IconCursorGrab, 'grab')}
        .react-flow__pane.dragging ${get_cursor(IconCursorGrabbing, 'grabbing')}
        .react-flow__minimap ${get_cursor(IconCursorGrab, 'grab')}
      `;

    document.head.appendChild(out);

    return out;
  }

  function get_cursor(cursor: FunctionComponent<SVGProps<SVGSVGElement>>, cursor_type: string) {
    return `{ cursor: url("${cursor}") 12 12, ${cursor_type} !important; }`;
  }
}
